import { useEffect } from "react";
import { Accordion } from 'react-light-accordion';
import MessageEmptyData from "../../../common/messageEmptyData";
import ShiftReportAccordion from './shiftReportAccordion';
import ShiftReportSummaryAccordion from './shiftReportSummaryAccordion';
import * as Shared from "../../../common/shared";

/**
 * Body component for ShiftReport Report
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ShiftReportBody = (prop) => {
    const { filters, data } = prop;

    useEffect(() => {
        Shared.toggleAllAccordionItems();
    }, [data]);

    if (!filters.isSubmitted) {
        return null;
    }

    if (data === null) {
        return <MessageEmptyData />;
    }

    return (
        <div className="container-fluid card-body">
            <div className="default-according panel-accordion" id="accordionclose">
                 <Accordion atomic="false">
                    <ShiftReportSummaryAccordion 
                        data={data.summary} 
                    />
                    {data.disciplines.map(discipline => {
                        return <ShiftReportAccordion 
                            key={discipline.name} 
                            title={discipline.name} 
                            data={discipline} 
                        />
                    })}
                </Accordion>
                {data.disciplines.length > 0 && (
                    <table className="table table-hover table-striped mt-5">
                        <thead>
                            <tr>
                                <th colSpan={2}>Total Cost Impact Per Discipline</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.total.map((total) => (
                                <tr key={total.name}>
                                    <td>{ total.name }</td>
                                    <td className="font-weight-bold">{ total.cost_impact.toLocaleString('en-US') }</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default ShiftReportBody;
